import * as actionTypes from './actionTypes';

export const fetchFeed = (spaceId) => ({
  type: actionTypes.FETCH,
  spaceId,
});
export const fetchFeedSuccess = (spaceId, ids) => ({
  type: actionTypes.FETCH_SUCCESS,
  spaceId,
  ids,
});
